import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import React from 'react';
import Joyride from 'react-joyride';
import { Button } from '../button';
import { IconID } from '../icon';
import { Typography } from '../typography';
import styles from './tour.module.scss';
var TourTestId;
(function (TourTestId) {
    TourTestId["TOOLTIP_BODY"] = "tour-tooltip-body";
    TourTestId["CLOSE_BUTTON"] = "tour-close-button";
    TourTestId["NEXT_BUTTON"] = "tour-next-button";
    TourTestId["BACK_BUTTON"] = "tour-back-button";
})(TourTestId || (TourTestId = {}));
export const Tour = ({ steps, showSkipButton = false, showProgress = false, continuous = true, showCloseButton = true, disableOverlay = false, spotlightCardWidth = 340, reverseFooterOrder = false, className, disableScrolling = false, zIndex = 4, onCloseButtonClick, ...restProps }) => {
    const { t } = useTranslation();
    const showTooltipFooter = showProgress || continuous || showSkipButton;
    /**
     * Custom Tooltip/Spotlight card to be shown as tooltip on each step.
     * Passed to Joyride Component.
     */
    const Tooltip = ({ 
    // eslint-disable-next-line no-shadow
    continuous, index, step, backProps, closeProps, primaryProps, skipProps, tooltipProps, isLastStep, size, }) => {
        const skipButtonText = restProps.skipButtonText || t('SKIP');
        const doneButtonText = restProps.doneButtonText || t('DONE');
        const nextButtonText = restProps.nextButtonText || t('NEXT');
        const backButtonText = restProps.backButtonText || t('BACK');
        const closeButtonText = restProps.closeButtonText || t('CLOSE');
        const nextButtonTextDisplay = isLastStep
            ? doneButtonText
            : nextButtonText;
        const nextButtonProps = {
            ...primaryProps,
            title: nextButtonTextDisplay,
        };
        const skipButtonProps = { ...skipProps, title: skipButtonText };
        const backButtonProps = { ...backProps, title: backButtonText };
        const closeButtonProps = { ...closeProps, title: closeButtonText };
        return (React.createElement("div", { className: styles.tooltip, style: { width: `${spotlightCardWidth}px` }, ...tooltipProps, "data-testid": TourTestId.TOOLTIP_BODY },
            step.title && (React.createElement(Typography, { variant: "section-label", className: styles.title }, step.title)),
            React.createElement(Typography, { variant: "body-normal", className: cx(styles.content, styles.tourStepContent), overrideTag: "div" }, step.content),
            showTooltipFooter && (React.createElement("footer", { className: reverseFooterOrder
                    ? styles.reverseFooter
                    : styles.footer },
                showProgress && (React.createElement(Typography, { variant: "footnote", className: styles.progressIndicator, overrideTag: "span" }, t('tour.steps', {
                    current: index + 1,
                    total: size,
                }))),
                React.createElement("div", { className: reverseFooterOrder
                        ? styles.reverseFooterButtonWrapper
                        : styles.footerButtonWrapper },
                    showSkipButton && (React.createElement(Button, { type: "tertiary", size: "xs", text: skipButtonText, backgroundType: "colored", className: styles.footerBtn, ...skipButtonProps })),
                    continuous && index > 0 && (React.createElement(Button, { type: "tertiary", size: "xs", text: backButtonText, backgroundType: "colored", className: styles.footerBtn, "data-testid": TourTestId.BACK_BUTTON, ...backButtonProps })),
                    continuous && (React.createElement(Button, { type: "secondary", size: "s", text: nextButtonTextDisplay, className: styles.footerBtn, "data-testid": TourTestId.NEXT_BUTTON, ...nextButtonProps }))))),
            showCloseButton && (React.createElement(Button, { className: styles.closeBtn, size: "s", icon: IconID.CROSS, ...closeButtonProps, "data-testid": TourTestId.CLOSE_BUTTON, onClick: onCloseButtonClick }))));
    };
    const Beacon = React.forwardRef((props, ref) => (React.createElement("button", { type: "button", ref: ref, className: styles.beacon, ...props },
        React.createElement("span", { className: styles.beaconPulse }),
        React.createElement("span", { className: styles.beaconInner }))));
    return (
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    React.createElement(Joyride, { steps: steps, disableCloseOnEsc: true, continuous: continuous, beaconComponent: Beacon, styles: {
            options: {
                arrowColor: '#2E75F0',
                ...(disableOverlay && { overlayColor: 'rgba(0, 0, 0, 0)' }),
                zIndex,
            },
        }, tooltipComponent: Tooltip, disableOverlay: disableOverlay, ...restProps, disableScrolling: true }));
};
//# sourceMappingURL=tour.js.map